import { Directive, Component, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Directive()
export abstract class HandleSubscriptionsComponent implements OnDestroy {

  private subscriptions:Subscription[] = [];

  constructor() {}

  handleSubscription(source: Observable<any>, handler: any, errorHandler?:any) {
    const sub = source.subscribe(
        (res) => {
            handler(res);
        },
        (err) => {
            errorHandler(err);
        }
    );
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    for (const sub of this.subscriptions){
      sub.unsubscribe();
    }
  }

  
}